import type { Components } from '@mui/material/styles';

export default function MuiCardMedia(): Components['MuiCardMedia'] {
  return {};
}
